import store from '@/store';
import { server, domRoot } from './SERVER_ADDR';
export const SERVER_ADDR = server;
export const AJAX_REQ_ADDR = `${SERVER_ADDR}/online/ajax`;
export const AJAX_FILE_REQ_ADDR = `${SERVER_ADDR}/online/ajax-file`;
// The pdf/ asset bundle lives in public/pdf/ and is served statically by
// the FE container (or webpack-dev-server in local dev).
export const PDF_VIEWER_ADDRESS = `${domRoot}/pdf/viewer.html`;
export const DEFAULT_REQUEST_URL = '/online/ajax';
export const DEFAULT_FILE_REQUEST_URL = '/online/ajax-file';
// `SESSIONLESS_CONTROLLER` used to live here. Nothing may build a `/sessionless`
// URL any more: the bridge intercepts every one of them and maps none, and the
// operations behind them — registering, verifying, choosing a password — either
// moved to `POST /users` or belong to pacmny-auth. It had no importers even
// while the family was still live.

/**
 * Composes a request configuration object for axios
 * @param {object} reqData data 
 * @param {string} reqAction action  
 * @param {string} reqUrl /CONTROLLER/ACTION
 */
export function getRequestConfig (reqData, reqAction, reqUrl=DEFAULT_REQUEST_URL, reqMethod='post') {
  const data = {data: reqData, action: reqAction};
  let csrf = store.getters['login/getCsrf'];
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: csrf ? { ...data,[csrf.param] : csrf.token } : data,
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}, 
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
    withCredentials: true,
  };
}
export function getBinaryFileRequestConfig(reqData, reqAction) {
  const data = {data: reqData, action: reqAction};
  return {
    method: 'post',
    url: AJAX_REQ_ADDR,
    data: data,
    resposneType: 'arraybuffer',
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': '*/*'}, 
    withCredentials: true,
  };

}

// `getPdfRequestConfig` used to sit here. Its only two callers were `getPdfById`
// and `getReportById`, which posted to pacmny-be's `/file/pdfs` and
// `/file/reports` — a pair with no bridge entry, so both threw. They read
// `GET /pdf-documents/{pdf}/content` and `GET /reports/{report}/content` now,
// which stream the bytes with a Bearer token and need no envelope, no CSRF pair
// and no cookie.

export function getBlobRequestConfig(reqData, reqAction, reqUrl=DEFAULT_REQUEST_URL, reqMethod='post') {
  let csrf = store.getters['login/getCsrf'];
  const data = {data: reqData, action: reqAction};
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: csrf ? { ...data,[csrf.param] : csrf.token } : data,
    resposneType: 'blob',
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': '*/*'}, 
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
    withCredentials: true,
  };
}

export function getFileUploadRequestConfig(formData, reqAction, reqUrl=DEFAULT_FILE_REQUEST_URL, reqMethod='post') {
  // formData.set('action-field', reqAction);
  formData['action-field'] = reqAction;
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: formData,
    headers: {'Content-Type': 'multipart/form-data'}, 
    withCredentials: true,
  };
}
export function getFileDownloadRequestConfig(data, reqAction) {
  return {...getRequestConfig(data,reqAction), responseType: 'blob'};
}

/* simulate single grab event config */
export function getFullPageExtractionRequestConfig(pdfId, pageNumber, pageWidth, pageHeight, pageRotation) {
  return {
    pdfId: pdfId,
    source: {
      selections: [
        {
          selection: {
            top: 0,
            left: 0,
            right: pageWidth,
            bottom: pageHeight,
            width: pageWidth,
            height: pageHeight,
            x: 0,
            y: 0,
          },
          intersections: [
            {
              pageNumber: pageNumber,
              rectangle: {
                top: 0,
                left: 0,
                right: pageWidth,
                bottom: pageHeight,
                width: pageWidth,
                height: pageHeight,
              }
            }
          ],
        }
      ],
      rotation: pageRotation,
      referencedPages: [
        {
          rectangle: {
            top: 0,
            left: 0,
            width: pageWidth,
            height: pageHeight,
          },
          // The width and height here are the page's own size in PDF points
          // (the viewer reports them at scale 1), the same as the viewer's
          // own `pdfSize` on a drawn selection.
          pdfSize: { width: pageWidth, height: pageHeight },
          pageNumber: pageNumber,
        }
      ]
    },
    destination: {
      width: pageWidth,
      height: pageHeight,
    }
  };
}

